import * as TonalInterval from '@tonaljs/interval';

/**
 * Gets the interval between two notes
 * @param noteA - First note
 * @param noteB - Second note
 * @returns Interval name
 */
export function getInterval(noteA: string, noteB: string): string {
  return TonalInterval.distance(noteA, noteB);
}

/**
 * Converts interval notation from functional format (e.g., "3m") to traditional music theory format (e.g., "m3")
 * @param interval The interval in functional format (number first, quality second)
 * @returns The interval in traditional format (quality first, number second), or "?" if invalid
 */
export function formatTraditionalInterval(interval: string | undefined): string {
  // Handle undefined/null case
  if (!interval) {
    return '?';
  }

  // Handle empty string
  if (interval.trim() === '') {
    return '?';
  }

  if (interval.length >= 2) {
    // Extract the numeric part (could be 1, 2, 3... digits) and the quality part
    let numberPart = '';
    let qualityPart = '';

    // Find where the letters start
    let i = 0;
    while (i < interval.length && /\d/.test(interval.charAt(i))) {
      numberPart += interval.charAt(i);
      i++;
    }
    qualityPart = interval.substring(i);

    // Flip the order to traditional format
    return qualityPart + numberPart;
  }

  // If parsing fails for any reason, return ? for consistency
  return '?';
}
